import { UserDefaultIcon } from '@practium/ui';

export const adminUsersChartData = [
	{ month: '01', realizado: 12, planejado: 10 },
	{ month: '02', realizado: 15, planejado: 12 },
	{ month: '03', realizado: 18, planejado: 15 },
	{ month: '04', realizado: 14, planejado: 18 },
	{ month: '05', realizado: 22, planejado: 16 },
	{ month: '06', realizado: 25, planejado: 20 },
	{ month: '07', realizado: 20, planejado: 22 },
	{ month: '08', realizado: 17, planejado: 20 },
	{ month: '09', realizado: 24, planejado: 18 },
	{ month: '10', realizado: 21, planejado: 22 },
	{ month: '11', realizado: 28, planejado: 24 },
	{ month: '12', realizado: 32, planejado: 28 },
];

export const adminUsersChartConfig = {
	title: 'Novos Usuários',
	mainValue: '248 Usuários',
	trendValue: '12.8%',
	trendLabel: 'vs ano anterior',
	trendDirection: 'up' as const,
	footerText: 'Cadastros de Jan-Dez, ' + new Date().getFullYear(),
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
	xAxisKey: 'month',
	bar1Key: 'realizado',
	bar1Label: 'Realizado',
	bar2Key: 'planejado',
	bar2Label: 'Planejado',
};

export const adminUserTypesDonutData = [
	{ name: 'Agricultores', value: 145, color: 'var(--chart-donut-dark)' },
	{ name: 'Consultores', value: 68, color: 'var(--chart-donut-medium)' },
	{ name: 'Empresas', value: 35, color: 'var(--chart-donut-light)' },
];

export const adminUserTypesDonutConfig = {
	title: 'Usuários por Tipo',
	subtitle: 'Distribuição na plataforma',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
};

export const adminSubscriptionsChartData = [
	{ name: 'Ativas', value: 186 },
	{ name: 'Trial', value: 42 },
	{ name: 'Canceladas', value: 20 },
];

export const adminSubscriptionsChartConfig = {
	title: 'Status de Assinaturas',
	subtitle: 'Distribuição de planos na plataforma',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
};

export const adminPlansData = [
	{ id: 1, name: 'Plano Business', value: '89 Assin.', icon: UserDefaultIcon },
	{ id: 2, name: 'Plano Professional', value: '67 Assin.', icon: UserDefaultIcon },
	{ id: 3, name: 'Plano Starter', value: '52 Assin.', icon: UserDefaultIcon },
	{ id: 4, name: 'Plano Enterprise', value: '20 Assin.', icon: UserDefaultIcon },
];

export const adminPlansConfig = {
	title: 'Planos Mais Contratados',
	subtitle: 'Distribuição de assinaturas por plano',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
};

export const adminActivityLineData = [
	{ day: '01', current: 142, previous: 125 },
	{ day: '02', current: 158, previous: 138 },
	{ day: '03', current: 165, previous: 145 },
	{ day: '04', current: 152, previous: 160 },
	{ day: '05', current: 178, previous: 155 },
	{ day: '06', current: 185, previous: 165 },
];

export const adminActivityLineConfig = {
	title: 'Acessos à Plataforma',
	mainValue: '980 Acessos',
	trendValue: '15.3%',
	trendLabel: 'vs semana anterior',
	trendDirection: 'up' as const,
	footerText: 'Atividade de 1-6 Dez, 2025',
	buttonText: 'Ver Relatório',
	onButtonClick: () => { },
	xAxisKey: 'day',
	line1Key: 'current',
	line1Label: 'Semana atual',
	line2Key: 'previous',
	line2Label: 'Semana anterior',
	tooltipTitle: 'Acessos',
};
